import { Fragment, useEffect, useState } from "react";
import { Card, ConfigProvider, DatePicker, Row, Select, Spin } from "antd";
import { Form, Input, Button, List, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteWellTopAttr,
  getWellInfo,
  getWellTops,
  saveWellTops,
} from "service/petrophysics";
import { getWellTopDict } from "service/tops";
import enUS from "antd/locale/en_US";
import dayjs from "dayjs";
import { getAssets } from "service/assets";
import {
  deleteWell,
  saveWellSummary,
  updateWellSummary,
  getWellSummaryDict,
} from "service/wellSummary";
import {
  getWellDeviation,
  removeWellDeviation,
  saveWellDeviation,
  getWellDeviationDict,
} from "service/deviation";
// import { ExclamationCircleFilled } from "@ant-design/icons";
import EditorTable from "../component/EditorTable";
import useLoading from "components/common/useLoading";
import { titleCase } from "utils/dataUtil";

const { Title } = Typography;
// const { confirm } = Modal;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 },
};

const wellInputs = [
  {
    name: "name",
    label: "Name",
    fields: [
      {
        name: "well_name",
        label: "Well Name:",
        rule: [{ required: true, message: "Please input a well name!" }],
        type: "Input",
        disabled: false,
        value: "",
      },
      {
        name: "uwi",
        label: "UWI:",
        rule: [{ required: true, message: "Please input an uwi!" }],
        type: "Input",
        disabled: false,
        value: "",
      },
    ],
  },
  {
    name: "lease",
    label: "Lease",
    fields: [
      {
        name: "asset",
        label: "Asset:",
        rule: [{ required: false }],
        type: "Select",
        disabled: false,
      },
      //   {
      //     name: "lease_name",
      //     label: "Lease Name:",
      //     rule: [{ required: false }],
      //     type: "Input",
      //     disabled: false,
      //   },
      //   {
      //     name: "county",
      //     label: "County:",
      //     rule: [{ required: false }],
      //     type: "Input",
      //     disabled: false,
      //   },
      //   {
      //     name: "state",
      //     label: "State:",
      //     rule: [{ required: false }],
      //     type: "Input",
      //     disabled: false,
      //   },
      //   {
      //     name: "basin",
      //     label: "Basin:",
      //     rule: [{ required: false }],
      //     type: "Input",
      //     disabled: false,
      //   },
      //   {
      //     name: "reservoir_name",
      //     label: "Reservoir:",
      //     rule: [{ required: false }],
      //     type: "Input",
      //     disabled: false,
      //   },
    ],
  },
  // {
  //   name: "gng",
  //   label: "G&G",
  //   fields: [
  //     {
  //       name: "well_log",
  //       label: "Well Log:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //     {
  //       name: "well_top",
  //       label: "Well Top:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //   ],
  // },
  // {
  //   name: "drilling",
  //   label: "Drilling",
  //   fields: [
  //     {
  //       name: "latitude",
  //       label: "Latitude:",
  //       rule: [{ required: true }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "longitude",
  //       label: "Longitude:",
  //       rule: [{ required: true }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "measured_depth",
  //       label: "Measured Depth:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "well_deviation_available",
  //       label: "Well Deviation:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: false,
  //     },
  //     {
  //       name: "well_survey_available",
  //       label: "Well Survey:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: false,
  //     },
  //   ],
  // },
  // {
  //   name: "production",
  //   label: "Production",
  //   fields: [
  //     {
  //       name: "well_type",
  //       label: "Well Type:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "drill_type",
  //       label: "Drill Type:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "producing_status",
  //       label: "Producing Status:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "production_type",
  //       label: "Production Type:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "artificial_lift_type",
  //       label: "Artificial Lift Type:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "artificial_lift_data_available",
  //       label: "Artificial Lift Data:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //     {
  //       name: "production_data_available",
  //       label: "Production Data:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //     {
  //       name: "injection_data_available",
  //       label: "Injection Data:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //     {
  //       name: "monitoring_available",
  //       label: "Monitoring:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       disabled: true,
  //     },
  //   ],
  // },
  // {
  //   name: "completion",
  //   label: "Completion",
  //   fields: [
  //     {
  //       name: "completion_available",
  //       label: "Completion:",
  //       rule: [{ required: false }],
  //       type: "Select",
  //       options: [
  //         { value: "1", label: "1" },
  //         { value: "2", label: "2" },
  //       ],
  //       disabled: true,
  //     },
  //     {
  //       name: "total_sand_usage",
  //       label: "Sand Usage:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "wellbore_length",
  //       label: "Wellbore Length:",
  //       rule: [{ required: false }],
  //       type: "Input",
  //       disabled: false,
  //     },
  //     {
  //       name: "spud_date",
  //       label: "Spud Date:",
  //       rule: [{ required: false }],
  //       type: "Date",
  //       disabled: false,
  //     },
  //     {
  //       name: "last_prod_date",
  //       label: "Last Production Date:",
  //       rule: [{ required: false }],
  //       type: "Date",
  //       disabled: false,
  //     },
  //   ],
  // },
  {
    name: "more",
    label: "More",
    fields: [],
  },
];

const deviationColumns = [
  // {
  //   title: "UWI",
  //   dataIndex: "uwi",
  //   key: "uwi",
  //   editable: false,
  // },
];

const topColumns = [
  // {
  //   title: "UWI",
  //   dataIndex: "uwi",
  //   key: "uwi",
  //   editable: false,
  // },
  // {
  //   title: "Name",
  //   dataIndex: "well_name",
  //   key: "well_name",
  // },
  {
    title: "Top Name",
    dataIndex: "top_name",
    key: "top_name",
  },
];

const WellInfo = (props) => {
  const { wellInfo, assets } = props;
  const { loadingIconActions } = props;
  const [showLoadingIcon, hideLoadingIcon] = loadingIconActions || [];
  const [form] = Form.useForm();
  const [showMore, setShowMore] = useState(false);
  const [initValue, setInitValue] = useState(null);
  const [assetOptions, setAssetOptions] = useState([]);
  const [submitState, setSubmitState] = useState("modify");
  const navigate = useNavigate();

  useEffect(() => {
    if (!wellInfo || Object.keys(wellInfo) === 0) return;
    let data = { ...wellInfo };
    if (wellInfo.asset) {
      data.asset = wellInfo.asset.id;
    }
    setInitValue({ ...data });
  }, [wellInfo]);

  useEffect(() => {
    if (assets == null || assets.length === 0) return;
    let options = assets.map((asset) => ({
      value: asset.id,
      label: asset.asset_name,
    }));
    setAssetOptions(options);

    for (let item of wellInputs) {
      for (let block of item.fields) {
        if (block.name === "asset") {
          block.options = options;
        }
      }
    }
  }, [assets]);

  useEffect(() => {
    getWellSummaryDict(
      (res) => {
        console.log("Get well summary dict successful. ", res);
        if (!res) return;
        let moreFields = wellInputs.find((item) => item.name === "more").fields;
        let columnKeys = moreFields.map((item) => item.name);
        for (let item of res) {
          if (
            item.element === "uwi" ||
            item.element === "well_name" ||
            item.element === "asset_name"
          ) {
            continue;
          }
          if (columnKeys.includes(item.element)) {
            continue;
          }
          let name = item.elemnt_fullname;
          if (!name) {
            name = titleCase(item.element);
          }

          if (item.element.includes("date")) {
            moreFields.push({
              name: item.element,
              label: name,
              rule: [{ required: false }],
              type: "Date",
              disabled: false,
            });
          } else if (item.element.includes("available")) {
            moreFields.push({
              name: item.element,
              label: name,
              rule: [{ required: false }],
              type: "Select",
              options: [
                { value: null, label: "N/A" },
                { value: 0, label: "Unavailable" },
                { value: 1, label: "Available" },
              ],
              disabled: true,
            });
          } else {
            moreFields.push({
              name: item.element,
              label: name,
              rule: [{ required: false }],
              type: "Input",
              disabled: false,
            });
          }
        }
      },
      (err) => {
        console.warn("Get well summary dict failed!", err.message);
      }
    );
  }, []);

  useEffect(() => {
    getWellDeviationDict(
      (res) => {
        console.log("Get well deviation dict successful. ", res);
        if (!res) return;
        let columnKeys = deviationColumns.map((item) => item.key);
        for (let item of res) {
          if (item.element === "uwi" || item.element === "well_name") {
            continue;
          }
          if (columnKeys.includes(item.element)) {
            continue;
          }
          let name = item.elemnt_fullname;
          if (!name) {
            name = titleCase(item.element);
          }
          deviationColumns.push({
            title: name,
            dataIndex: item.element,
            key: item.element,
            width: 120,
          });
        }
      },
      (err) => {
        console.warn("Get well deviation dict failed!", err.message);
      }
    );
  }, []);

  useEffect(() => {
    getWellTopDict(
      null,
      (res) => {
        console.log("Get well top dict successful. ", res);
        if (!res) return;
        let columnKeys = topColumns.map((item) => item.key);
        for (let item of res) {
          if (
            item.element === "uwi" ||
            item.element === "well_name" ||
            item.element === "top_name"
          ) {
            continue;
          }
          if (columnKeys.includes(item.element)) {
            continue;
          }
          let name = item.elemnt_fullname;
          if (!name) {
            name = titleCase(item.element);
          }
          topColumns.push({
            title: name,
            dataIndex: item.element,
            key: item.element,
            width: 120,
          });
        }
      },
      (err) => {
        console.warn("Get well top dict failed!", err.message);
      }
    );
  }, []);

  const handleInputChange = (e) => {
    const { name: nameList, value } = e[0];
    if (!nameList) return;
    const name = nameList[0];
    if (name !== "uwi") return;
    if (value !== wellInfo.uwi) {
      setSubmitState("new");
    } else {
      setSubmitState("modify");
    }
  };

  const onFinish = (values) => {
    const allValues = form.getFieldsValue();
    const { spud_date, last_prod_date } = allValues;
    if (spud_date != null) {
      allValues.spud_date = dayjs(spud_date).format("YYYY-MM-DD");
    }
    if (last_prod_date != null) {
      allValues.last_prod_date = dayjs(last_prod_date).format("YYYY-MM-DD");
    }
    showLoadingIcon && showLoadingIcon();
    let formData = {
      ...allValues,
      asset: assets.find((item) => item.id === allValues.asset),
    };
    if (submitState === "new") {
      saveWellSummary(
        formData,
        (res) => {
          console.log("Save well summaries successful. ", res);
          hideLoadingIcon && hideLoadingIcon();
          navigate("/well_editor/" + allValues.uwi, { replace: "true" });
        },
        (err) => {
          console.warn("Save well summaries failed!", err.message);
          hideLoadingIcon && hideLoadingIcon();
        }
      );
    } else if (submitState === "modify") {
      updateWellSummary(
        formData,
        (res) => {
          console.log("Update well summaries successful. ", res);
          hideLoadingIcon && hideLoadingIcon();
          navigate("/well_editor/" + allValues.uwi, { replace: "true" });
        },
        (err) => {
          console.warn("Update well summaries failed!", err.message);
          hideLoadingIcon && hideLoadingIcon();
        }
      );
    }
  };

  const onDelete = (values) => {
    let wellUwi = form.getFieldValue("uwi");
    if (!wellUwi) {
      console.warn("Null well name!");
      return;
    }
    showLoadingIcon();
    deleteWell(
      wellUwi,
      () => {
        navigate("/well_summary/", { replace: "true" });
        hideLoadingIcon();
      },
      () => hideLoadingIcon()
    );
    // confirm({
    //   title: 'Do you want to delete this well?',
    //   icon: <ExclamationCircleFilled />,
    //   content: '',
    //   onOk: () => {
    //     let wellUwi = form.getFieldValue("uwi");
    //     if (!wellUwi) {
    //       console.warn("Null well name!");
    //       return;
    //     }
    //     showLoadingIcon();
    //     deleteWells(
    //       [wellUwi],
    //       () => {
    //         navigate("/well_summary/", { replace: 'true' });
    //         hideLoadingIcon();
    //       },
    //       () => hideLoadingIcon()
    //     );
    //   },
    //   onCancel() {
    //   },
    // });
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const onReset = () => {
    setInitValue({});
    setSubmitState("new");
    form.resetFields();
    navigate("/well_editor/", { replace: "true" });
  };

  return (
    <Card
      title={
        <Title level={5}>
          Well Information
          <Button
            style={{ marginLeft: "10px", border: 0 }}
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? "less" : "more"}...
          </Button>
        </Title>
      }
      bordered={false}
      style={{ marginLeft: "0.5em", marginRight: "0.5em" }}
    >
      {wellInfo && initValue && (
        <Form
          {...layout}
          form={form}
          name="nest-messages"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initValue}
          // initialValues={wellInfo}
          onFieldsChange={handleInputChange}
        >
          {wellInputs
            .filter((item, index) => (showMore ? true : index === 0))
            .map((block, index) => {
              return (
                <Fragment key={index}>
                  <h3>{block.label}</h3>
                  <List
                    grid={{ column: 2 }}
                    dataSource={block.fields}
                    renderItem={(field) => (
                      <List.Item>
                        <Form.Item
                          name={field.name}
                          label={field.label}
                          rules={field.rule}
                        >
                          {field.type === "Input" ? (
                            <Input />
                          ) : field.type === "Select" ? (
                            <Select options={field.options} />
                          ) : field.type === "Date" ? (
                            <DatePicker disabled={field.disabled} />
                          ) : (
                            ""
                          )}
                        </Form.Item>
                      </List.Item>
                    )}
                  />
                </Fragment>
              );
            })}

          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 6 }}>
            <Row justify={"space-around"}>
              <Button type="primary" htmlType="submit">
                {submitState === "new" ? "Submit" : "Modify"}
              </Button>
              <Button
                htmlType="reset"
                onClick={onReset}
                disabled={!wellInfo?.uwi}
              >
                New Well
              </Button>
              <Button
                htmlType="button"
                onClick={onDelete}
                style={{ color: "red" }}
              >
                Delete
              </Button>
            </Row>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
};

function WellEditor2() {
  const [LoadingIcon, showLoadingIcon, hideLoadingIcon] = useLoading(
    <Spin size="large" />,
    50
  );
  const { uwi } = useParams();
  const [assets, setAssets] = useState(null);
  const [wellInfo, setWellInfo] = useState(null);

  useEffect(() => {
    showLoadingIcon();
    getAssets(
      (result) => {
        hideLoadingIcon();
        setAssets(result);
      },
      (error) => {
        hideLoadingIcon();
      }
    );
  }, [showLoadingIcon, hideLoadingIcon]);

  useEffect(() => {
    if (!uwi) {
      setWellInfo({});
      return;
    }

    showLoadingIcon();
    getWellInfo(
      uwi,
      (res) => {
        hideLoadingIcon();
        if (!res) return;
        let data = { ...res };
        let { spud_date, last_prod_date } = res;
        if (spud_date) {
          spud_date = dayjs(spud_date, "YYYY-MM-DD");
          data.spud_date = spud_date;
        }
        if (last_prod_date) {
          last_prod_date = dayjs(last_prod_date, "YYYY-MM-DD");
          data.last_prod_date = last_prod_date;
        }
        setWellInfo({ ...data });
      },
      (err) => {
        console.warn("Load well info failed! uwi: ", uwi);
        hideLoadingIcon();
      }
    );
  }, [uwi, hideLoadingIcon, showLoadingIcon]);

  const topColumnHandler = (cols, data) => {
    let columnsResult = [...cols];
    const [topData] = data;

    const { tops } = topData;

    Object.keys(tops).map((topName) => {
      columnsResult.push({
        title: topName,
        dataIndex: ["tops", topName, "MD"],
        key: topName,
      });
      return null;
    });
    return columnsResult;
  };

  return (
    <div style={{ height: "91vh", overflow: "auto" }}>
      <LoadingIcon />
      <ConfigProvider
        locale={enUS}
        componentSize="middle"
        theme={{
          token: {},
          components: {},
        }}
      >
        <WellInfo
          wellInfo={wellInfo}
          assets={assets}
          loadingIconActions={[showLoadingIcon, hideLoadingIcon]}
        />

        <EditorTable
          columns={deviationColumns || []}
          title="Well Deviation"
          dataFetcher={[
            () => {
              return uwi;
            },
            getWellDeviation,
            (res) => {
              let data = res.deviations;
              if (!data) return [];
              return data.map((item, index) => ({
                ...item,
                index: index,
                id: index,
              }));
            },
          ]}
          dataSaver={[
            saveWellDeviation, // update new record
            (rec, row) => {
              const record = { ...rec };
              delete record.index;
              delete record.id;
              return [
                {
                  // azimuth: null,
                  // inclination: null,
                  // kelly_bushing: null,
                  // latitude: 0,
                  // longitude: 0,
                  // measured_depth: null,
                  // subsea_depth: null,
                  // tvd: null,
                  uwi: uwi,
                  ...record,
                },
              ];
            },
            saveWellDeviation, // save new record
            (rec, row, data) => {
              // console.log("data==>", data)
              const record = { ...rec };
              delete record.index;
              delete record.id;
              let rowIds = data.map((item) => item.import_row_id).sort();
              let import_row_id = rowIds[rowIds.length - 1] + 1;
              return [
                {
                  // azimuth: null,
                  // inclination: null,
                  // kelly_bushing: null,
                  // latitude: 0,
                  // longitude: 0,
                  // measured_depth: null,
                  // subsea_depth: null,
                  // tvd: null,
                  uwi: uwi,
                  import_row_id: import_row_id,
                  ...record,
                },
              ];
            },
          ]}
          dataRemover={[
            removeWellDeviation,
            (record) => ({
              deviations: [
                { uwi: uwi, import_row_id: record.get("import_row_id") },
              ],
            }),
          ]}
        />

        <EditorTable
          title="Well Top"
          // uwi={uwi}
          columns={topColumns || []}
          showNewRow={(data) => {
            // if no data, show new data button
            return !(data && data.length > 0);
          }}
          // columnFetcher={topColumnHandler}
          dataFetcher={[
            () => {
              return uwi;
            },
            (uwi, succeed, fail) => getWellTops(uwi, null, succeed, fail),
            (res) => {
              let data = res[0];
              if (!data) return [];
              // if (data.id === undefined || data.id === null)
              //   data["id"] = data.uwi.slice(4, -4);
              let records = [];
              let tops = data.tops;
              return Object.keys(tops).map((key, index) => ({
                ...tops[key],
                top_name: key,
                uwi: data.uwi,
                well_name: data.well_name,
                index: index,
                id: index,
              }));
            },
          ]}
          dataSaver={[
            saveWellTops,
            (record) => {
              let result = {},
                tops = {};
              let values = { ...record };
              delete values.index;
              delete values.uwi;
              delete values.well_name;
              delete values.id;
              delete values.top_name;
              tops[record.top_name] = { ...values };

              result[record.uwi] = tops;
              return result;
            },
          ]}
          dataRemover={[
            deleteWellTopAttr,
            (record) => {
              let result = {},
                tops = {};

              let values = { ...record };
              delete values.index;
              delete values.uwi;
              delete values.well_name;
              delete values.id;
              delete values.top_name;

              tops[record.top_name] = [...Object.keys(values)];
              result[record.uwi] = tops;

              return result;
            },
          ]}
        />
      </ConfigProvider>
    </div>
  );
}

export default WellEditor2;
